<!--todo 非单向数据流1-->
<template>
  <div
    v-if="!value.row.breakdown_object_id"
    style="width: 200px"
    v-loading="editLoading"
  >
    <!-- 日预算 -->
    <div v-if="value.row.daily_budget">
      <span v-if="!isEditing">
        {{ formattedMoney(value.row.daily_budget) }}
        <i
          v-if="canEdit"
          class="el-icon-edit-outline"
          style="cursor: pointer"
          @click="beforeEditBudget(true)"
        />
      </span>
      <span v-else>
        <el-input
          v-model="budgetEditing"
          v-cell-focus
          size="small"
          @input="refreshTableRow"
          @blur="cancelEditBudget"
          @change="editBudget(true)"
        />
      </span>
      <br />
      <span
        class="color9"
        style="margin-right: 10px"
        >日预算</span
      >
      <el-tag
        v-show="value.row.status === 'ACTIVE'"
        size="mini"
        style="cursor: pointer"
        @click="setTimeEditBudgetHandle()"
        data-clarity-region="fb-time-update-budget"
        >定时改预算</el-tag
      >
    </div>

    <!-- 总预算 -->
    <div v-else-if="value.row.lifetime_budget">
      <span v-if="!isEditing">
        {{ formattedMoney(value.row.lifetime_budget) }}
        <i
          v-if="canEdit"
          class="el-icon-edit-outline"
          style="cursor: pointer"
          @click="beforeEditBudget(false)"
        />
      </span>
      <span v-else>
        <el-input
          v-model="budgetEditing"
          v-cell-focus
          size="small"
          @input="refreshTableRow"
          @blur="cancelEditBudget"
          @change="editBudget(false)"
        />
      </span>
      <br />
      <span style="margin-right: 10px">总预算</span>
        <el-tag
          v-show="value.row.status === 'ACTIVE'"
          size="mini"
          style="cursor: pointer"
          @click="setTimeEditBudgetHandle()"
          >定时改预算</el-tag
        >
    </div>

    <!-- 无预算提示 -->
    <div v-else-if="value.row.level === 'campaign'">使用广告组预算</div>
    <div v-else-if="value.row.level === 'adset'">使用广告系列预算</div>
    <div v-else>-</div>

    <!-- 广告系列预算开关 -->
    <div
      v-if="value.row.level === 'campaign'"
      class="trans"
    >
      <span style="color: #999; font-size: 12px">是否开启广告系列预算：</span>
      <el-popover
        placement="top-start"
        title="转换预算"
        width="500"
        trigger="click"
        :content="cboTipText"
      >
        <el-switch
          slot="reference"
          v-model="is_cbo"
          size="mini"
          @change="transBudget"
        />
      </el-popover>
    </div>

    <edit-buyget-type
      :editBuygetTypeShow.sync="editBuygetTypeShow"
      :row="row"
      :date-range="dateRange"
      :is_cbo.sync="is_cbo"
      :textList="textList"
      @refreshTable="refreshData"
    />

    <set-time-edit-budget
      ref="setTimeEditBudget"
      :row="rowWithThirdNum"
      :level="value.row.level"
      platform="facebook"
      :needDec100="true"
      :gimpUserId="userInfo.data.id"
      @settingComplete="handleSettingComplete"
    />
  </div>
</template>

<script>
import { mutatePricing } from '@/api/adManagement';
import { mapGetters, mapState } from 'vuex';
import editBuygetType from './editBuygetType';
import { setTimeEditBudget } from '@adCommonComponent';
import { guardOwner } from '@/utils/ownerGuard';

export default {
  name: 'AdCellInlineEditBudget',
  components: {
    editBuygetType,
    setTimeEditBudget,
  },
  directives: {
    'cell-focus': {
      bind(el) {
        setTimeout(() => el.children[0]?.focus(), 200);
      },
    },
  },
  props: {
    value: {
      type: Object,
    },
    dateRange: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      editBuygetTypeShow: false,
      is_cbo: false,
      budgetEditing: null,
      isEditing: false,
      editLoading: false, //调接口过程
      textList: [
        '使用广告系列预算优化后，投放中的广告的剩余预算将合并为一项广告系列预算，广告系列预算优化会在启用15分钟后生效，你需要两小时后才能关闭这项功能',
        '关闭广告系列预算优化后，会把未花费的预算分配到各个广告组，各个广告组会使用相同的竞价策略和竞价上限(如适用)，如关闭广告系列预算优化，你需要2小时后才能再次打开',
      ],
    };
  },
  computed: {
    ...mapGetters(['toFormatedMoney']),
    ...mapState('user', ['userInfo']),

    canEdit() {
      const status = this.value.row.effective_status;
      return status !== 'ARCHIVED' && status !== 'DELETED';
    },
    cboTipText() {
      return this.is_cbo ? this.textList[1] : this.textList[0];
    },

    row() {
      const { campaign_id, adset_id, rowAccountId } = this.value.row;
      return {
        ...this.value.row,
        campaignId: campaign_id,
        adGroupId: adset_id,
        adGroupAdId: adset_id,
        adAccountId: rowAccountId,
      };
    },

    rowWithThirdNum() {
      return {
        ...this.row,
        rowThirdNum: this.value.row.rowThirdNum,
      };
    },
  },
  created() {
    this.is_cbo = !!(this.value.row.daily_budget || this.value.row.lifetime_budget);
  },
  methods: {
    // 定时改预算
    async setTimeEditBudgetHandle() {
      if (!(await guardOwner(this.value.row))) return;
      this.$clarity.trackEvent('fb_投放助手_定时改预算');
      this.$refs.setTimeEditBudget.dialogVisible = true;
    },

    handleSettingComplete(formData, type, id, budgetAmount, taskId, data) {
      // adCommonComponent 的 setTimeEditBudget 操作的是 rowWithThirdNum（新对象）
      // 需要把结果同步回 value.row
      const row = this.value.row;
      if (!row.open_schedule) {
        this.$set(row, 'open_schedule', []);
      }
      const scheduleData = {
        type: 2,
        timeStr: formData.dateVal,
        dailyBudget: row.daily_budget ? budgetAmount : undefined,
        lifetimeBudget: row.lifetime_budget ? budgetAmount : undefined,
        id: taskId,
        ...data,
      };
      row.open_schedule.push(scheduleData);
    },

    close() {
      this.is_cbo = !this.is_cbo;
    },

    refreshTableRow() {
      this.$emit('scope-row-changed', this.value);
    },

    refreshTable() {
      this.$emit('get-list');
    },

    refreshData(data) {
      const scope = this.value;
      scope.row = { ...scope.row, ...data };
      this.$emit('scope-row-changed', scope);
    },

    cancelEditBudget() {
      const row = this.value.row;
      const result = this.$store.getters.toBaseMoney(this.budgetEditing);
      const currentBudget = parseInt(row.daily_budget) || parseInt(row.lifetime_budget);

      if (result === currentBudget) {
        this.isEditing = false;
        this.budgetEditing = null;
        this.refreshTableRow();
      }
    },

    formattedMoney(v) {
      return this.toFormatedMoney(v).formated || '';
    },

    async beforeEditBudget(isDaily) {
      if (!(await guardOwner(this.value.row))) return;
      const row = this.value.row;
      const budget = isDaily ? row.daily_budget : row.lifetime_budget;
      this.budgetEditing = this.$store.getters.toFormatedMoney(budget).value;
      this.isEditing = true;
      this.refreshTableRow();
    },

    editBudget(isDaily) {
      const row = this.value.row;
      const targetVal = this.$store.getters.toBaseMoney(this.budgetEditing);

      const params = {
        objects: [
          {
            id: row.id,
            name: row.name,
            level: row.level,
            daily_budget: isDaily ? targetVal : null,
            lifetime_budget: isDaily ? null : targetVal,
            before_lifetime_budget: row.lifetime_budget,
            before_daily_budget: row.daily_budget,
          },
        ],
        level: row.level,
        accountId: row.rowAccountId,
      };
      this.editLoading = true;
      mutatePricing(JSON.stringify(params))
        .then((res) => {
          this.editLoading = false;
          this.isEditing = false;
          this.budgetEditing = null;
          if (res.code === 0) {
            if (isDaily) {
              row.daily_budget = targetVal;
            } else {
              row.lifetime_budget = targetVal;
            }
          } else {
            this.$message({ type: 'warning', message: '失败了' });
          }
          this.refreshTableRow();
        })
        .catch(() => {
          this.editLoading = false;
        });
    },

    async transBudget() {
      if (!(await guardOwner(this.value.row))) {
        this.is_cbo = !this.is_cbo;
        return;
      }
      this.editBuygetTypeShow = true;
    },
  },
};
</script>

<style scoped>
.el-input {
  width: 80%;
}
</style>
